import React from "react";
import { inject, observer } from "mobx-react";
import { Item } from "src/models";
import { Files } from "src/components";
import { FileStore } from "src/stores";
import { FileType, IItem } from "src/types";

export interface IFileViewProps {
  item: Item<IItem>,
  fileStore?: FileStore;
}

export const FileView = inject("fileStore")(observer((props: IFileViewProps): JSX.Element => {

  const { fileStore } = props;

  return <Files
      files       = {fileStore.getItems}
      type        = {FileType.Document}
      onUpload    = {(f) => fileStore.addFileToItem(f)}
      onDelete    = {(f) => fileStore.removeFileFromItem(f)}
      alignUpload = 'bottom'
      hideHeading
    />
}));
